export const smallMobile = '360px';
export const mobile = '512px';
export const smallTablet = '768px';
export const tablet = '1024px';
export const desktop = '1280px';
export const desktopLg = '1281px';
